import React, { useEffect, useRef, useState } from 'react';
import { PadContainer, icons } from 'smartsuite-ui';
import PropTypes from 'prop-types';
import DetailItemContent from './DetailItemContent';
import { getTranslationKeyForNode } from '../utils/labelUtils';
import { useTranslation } from 'react-i18next';
import { stationSummaryNode } from '../utils/stationSummaryNode';

export default function DetailItem(props) {
    const { t } = useTranslation('bagSummary');
    const [height, setHeight] = useState(0);
    const contentRef = useRef(null);

    useEffect(() => {
        if (contentRef.current) {
            setHeight(contentRef.current.clientHeight);
        }
    }, [contentRef]);

    const isSelected = props.selectedStationCode == props.stationCode;
    const icon = isSelected ? '' : icons.plus;
    const styles = {
        gridTemplateRows: isSelected ? `${height}px` : 0,
    };
    const stationNodeDescription = t(
        getTranslationKeyForNode(stationSummaryNode(props.stationNodes))
    );
    const titleClassName = isSelected
        ? 'bag-detail-item__title'
        : 'bag-detail-item__title bag-detail-item__title--selected';

    return (
        <div className="bag-detail-item">
            <div
                className={titleClassName}
                onClick={() => props.onStationClick(props.stationCode)}
            >
                <b>{props.stationCode}:</b>
                <PadContainer cssClassModifiers={['pad-small']} />
                <span>{stationNodeDescription}</span>
                <div className="bag-detail-item__toggle-icon">
                    <span className={icon} />
                </div>
            </div>
            <div className="bag-detail-item__content" style={styles}>
                <div
                    className="bag-detail-item__content-overflow"
                    ref={contentRef}
                >
                    {props.stationNodes.map((nodeDetail) => (
                        <DetailItemContent
                            key={nodeDetail.sortOrder}
                            nodeDetail={nodeDetail}
                            urlData={props.urlData}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
}

DetailItem.propTypes = {
    onStationClick: PropTypes.func.isRequired,
    selectedStationCode: PropTypes.string.isRequired,
    stationCode: PropTypes.string.isRequired,
    stationNodes: PropTypes.instanceOf(Array),
    urlData: PropTypes.instanceOf(Object),
};
